var map = {
	"./bond/logo.svg": 38483,
	"./breathspec-covid01/logo.svg": 26579,
	"./inteliswab/logo.svg": 3136,
	"./luas/logo.svg": 33488,
	"./merck/logo.svg": 49751,
	"./transform/logo.svg": 60049,
	"./verifi-connect/logo.svg": 80833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86536;